import { render, staticRenderFns } from "./Carousel1Template.vue?vue&type=template&id=2b6c9be2"
import script from "./Carousel1Template.vue?vue&type=script&lang=js"
export * from "./Carousel1Template.vue?vue&type=script&lang=js"
import style0 from "./Carousel1Template.vue?vue&type=style&index=0&id=2b6c9be2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports